"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationSkeleton = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _styles = require("../Pagination/styles");
var _constants = require("./constants");
var _styles2 = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Skeleton component for `Pagination`.
 */
const PaginationSkeleton = ({
  animation = 'pulse',
  className
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    className: className,
    "data-testid": getTestId(_constants.PAGINATION_SKELETON),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.TextSkeleton, {
      variant: "rectangular",
      animation: animation
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.ProgressSkeleton, {
      variant: "rectangular",
      animation: animation
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.ButtonSkeleton, {
      variant: "rectangular",
      animation: animation
    })]
  });
};
exports.PaginationSkeleton = PaginationSkeleton;
//# sourceMappingURL=PaginationSkeleton.js.map